import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { format } from "date-fns";

import UploadingStatus from "features/medical-scribe/components/uploading-status.component";
import FieldLabel from "features/staff-tasks-v2/drawer/staff-task-card/field-label.component";
import StaffTaskPatientDisplay from "features/staff-tasks-v2/drawer/staff-task-card/staff-task-patient-display.component";

type PatientWithFullName = {
  fullName?: string;
  [key: string]: any;
};

type ScribeMetadataHeaderProps = {
  createdAt: string | undefined;
  patient: PatientWithFullName | undefined;
  status: number | undefined;
  duration: string | null | undefined;
  scribeId?: undefined | string | number;
};

export default function ScribeMetadataHeader({
  createdAt,
  patient,
  status,
  duration,
  scribeId
}: Readonly<ScribeMetadataHeaderProps>) {
  return (
    <Stack direction="row" columnGap={5}>
      <Stack rowGap={1.5}>
        <FieldLabel label="Created" sx={{ mb: "3px" }} />
        <Typography fontSize="16px" lineHeight="18px" mb={1}>
          {createdAt ? format(new Date(createdAt), "MM/dd/yyyy hh:mm aaa") : ""}
        </Typography>
      </Stack>

      {patient && (
        <Stack rowGap={1} sx={{ pr: 2, ml: 2.5, width: "fit-content" }}>
          <FieldLabel label="Patient" />
          <StaffTaskPatientDisplay
            isOpenInNewTab
            isComplete={false}
            variant="body2"
            patient={patient}
          />
        </Stack>
      )}

      <Stack rowGap={1.5}>
        <FieldLabel label="Status" sx={{ mb: "3px" }} />
        <UploadingStatus status={status} />
      </Stack>

      <Stack rowGap={1.5}>
        <FieldLabel label="Duration" sx={{ mb: "3px" }} />
        <Typography fontSize="16px" lineHeight="18px" mb={1}>
          {duration}
        </Typography>
      </Stack>
      {Boolean(scribeId) && (
        <Stack rowGap={1.5}>
          <FieldLabel label="Scribe Id" sx={{ mb: "3px" }} />
          <Typography fontSize="16px" lineHeight="18px" mb={1}>
            {scribeId}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
}
